import { render, staticRenderFns } from "./ForgotUsername.vue?vue&type=template&id=dc6173c4&scoped=true&"
import script from "./ForgotUsername.vue?vue&type=script&lang=js&"
export * from "./ForgotUsername.vue?vue&type=script&lang=js&"
import style0 from "./ForgotUsername.vue?vue&type=style&index=0&id=dc6173c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6173c4",
  null
  
)

export default component.exports